// This file exists so TanStack Router's file-based plugin keeps the
// /app/_layout route in the tree. The actual shell (header + bottom nav)
// lives in app.tsx which is the true parent of all /app/* routes.
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/_layout")({
  component: () => <Outlet />,
});
